import type { EntityType } from '@tunasong/schemas'
import React from 'react'

export interface LayoutContextType {
  query?: string
  typeFilter?: EntityType[]
}

export const LayoutContext = React.createContext<LayoutContextType | null>(null)
